import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const datasubject = createCrudVuexModule({
  namespaced: true,
  path: "/library/datasubject",

  state: {
    recommendations: undefined,
  },
  getters: {
    recommendations(state) {
      return state.recommendations;
    },
  },
  mutations: {
    recommendations(state, value) {
      state.recommendations = value;
    },
  },
  actions: {
    async paginateRecommendation({ commit, rootGetters }, { pagination, level, id }, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        const process = rootGetters["entityBoxes/process"];
        const datasource = rootGetters["entityBoxes/datasource"];
        const data = rootGetters["entityBoxes/data"];
        if (clearStateBeforeRest) {
          commit("recommendations", undefined);
        }

        const response = await rest.post(`/recommendation/paginate/datasubject`, { pagination, processId: process._id, datasourceId: datasource._id, dataId: data?._id });
        commit("recommendations", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
  },
});

export const datasubjectCategory = createCrudVuexModule({
  namespaced: true,
  path: "/library/datasubject-category",
});

export const workspaceDatasubject = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/datasubject",
});

export const workspaceDatasubjectCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/datasubject-category",
});

export const managementDatasubject = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/datasubject",
});

export const managementDatasubjectCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/datasubject-category",
});
